import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import OrderList from './OrderList';


function Order(props) {
    return (
        <Container>
        <Navbar/>

        <Content>
           <Header/>
          
         <div className='container-fluid'>
            <div className='row'>
            <OrderList/>
            </div>
         </div>
        </Content>
       

      </Container>
    );
}

export default Order;